import { render } from "./CoursesView.vue?vue&type=template&id=3840a962&scoped=true"
import script from "./CoursesView.vue?vue&type=script&lang=js"
export * from "./CoursesView.vue?vue&type=script&lang=js"

import "./CoursesView.vue?vue&type=style&index=0&id=3840a962&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3840a962"]])

export default __exports__